module.exports = __webpack_public_path__ + "static/media/Order-Manage.63d260b3.png";